import { DataToolStartEvent } from '@/entities/ai';
import { i18n } from '@/shared/i18n';

export const FINAL_STATUS_EVENT: DataToolStartEvent = {
  type: 'data-toolStart',
  data: {
    callId: 'tool.call.finalStatus',
    // A getter, not a value: resolving per read is what lets the label follow a language change.
    get toolName() {
      return i18n.t('chats:chats.agentTaskConstants.summaryInsights');
    },
    toolDescription: '',
    args: {},
  },
};
